import {Component, HostBinding, Input} from '@angular/core';
import {AbstractControl} from "@angular/forms";

@Component({
  selector: 'div[field-errors][control]',
  templateUrl: './field-errors.component.html',
  styleUrls: ['./field-errors.component.scss']
})
export class FieldErrorsComponent {

  @HostBinding('class.invalid-feedback')
  @Input() control: AbstractControl;

  get additionalErrors(): any {
    let controlErrors = Object.assign({}, this.control.errors);
    delete controlErrors.pattern;
    delete controlErrors.required;
    delete controlErrors.min;
    return controlErrors;
  }

}
